module.exports = __webpack_public_path__ + "img/IMG_0876.77ad55a5.jpeg";